import ExclusiveTyreFilter from './exclusive-tyre-filter';
import TyreFilterGroup from './tyre-filter-group';
import { compare, stringCompare, floatCompare, reverse } from '../../common/compare';
import _ from 'lodash';

function TyreRefinements(tyres, filterGroups = []) {
  this._tyres = tyres;
  this._filterGroups = filterGroups;
  filterGroups.forEach((filterGroup) => {
    filterGroup.setSource(this);
  });
}

function applyFilterGroups(groups, tyres) {
  return groups.reduce((remaining, filterGroup) => filterGroup.applyTo(remaining), tyres);
}

Object.assign(TyreRefinements.prototype, {
  filterGroups: function () {
    return this._filterGroups;
  },

  tyres: function () {
    return this._tyres;
  },

  applyAll: function () {
    return applyFilterGroups(this.filterGroups(), this.tyres());
  },

  applyExcept: function (filterGroup) {
    return applyFilterGroups(_.without(this.filterGroups(), filterGroup), this.tyres());
  },
});

export default function (tyres) {
  return new TyreRefinements(tyres, [
    new TyreFilterGroup(
      {
        header: 'Show only',
        inputType: 'radio',
        name: 'tyre-filter-simple',
        affectsCount: true,
      },
      [
        new ExclusiveTyreFilter(
          {
            id: 'top-picks-only',
            label: 'ClickMechanic top picks',
            active: !tyres.every((tyre) => tyre.top_pick),
            presence: (tyres) => tyres.some((tyre) => !tyre.top_pick),
          },
          (tyres) => tyres.filter((tyre) => tyre.top_pick),
        ),
        new ExclusiveTyreFilter(
          {
            id: 'manufacturer-specific-only',
            label: function () {
              if (this.presence(tyres)) {
                const manufacturer = tyres.find((tyre) => tyre.manufacturer_specific).manufacturer_specific;
                return manufacturer + ' specific';
              }
            },
            presence: (tyres) => tyres.some((tyre) => tyre.manufacturer_specific),
          },
          (tyres) => tyres.filter((tyre) => tyre.manufacturer_specific),
        ),
        new ExclusiveTyreFilter(
          {
            id: 'runflat-only',
            label: 'Run-flat only',
            presence: (tyres) => tyres.some((tyre) => tyre.rft),
          },
          (tyres) => tyres.filter((tyre) => tyre.rft),
        ),
        new ExclusiveTyreFilter(
          {
            id: 'xl-only',
            label: 'XL only',
            presence: (tyres) => tyres.some((tyre) => tyre.xl),
          },
          (tyres) => tyres.filter((tyre) => tyre.xl),
        ),
        new ExclusiveTyreFilter(
          {
            id: 'top-pick-any',
            label: 'All',
            active: tyres.every((tyre) => tyre.top_pick),
            presence: (tyres) => true,
          },
          (tyres) => tyres,
        ),
      ],
    ),
    new TyreFilterGroup(
      {
        header: 'Order by',
        inputType: 'radio',
        name: 'tyre-filter-order-by',
        affectsCount: false,
      },
      [
        new ExclusiveTyreFilter(
          {
            id: 'price-low-to-high',
            label: 'Price: low to high',
            active: true,
            presence: (tyres) => true,
          },
          (tyres) => tyres.sort(compare(stringCompare('position'), floatCompare('fitted_price'))),
        ),
        new ExclusiveTyreFilter(
          {
            id: 'price-high-to-low',
            label: 'Price: high to low',
            presence: (tyres) => true,
          },
          (tyres) => tyres.sort(compare(stringCompare('position'), reverse(floatCompare('fitted_price')))),
        ),
        new ExclusiveTyreFilter(
          {
            id: 'wet-grip-best-to-worst',
            label: 'Wet grip (A - F)',
            presence: (tyres) => true,
          },
          (tyres) => tyres.sort(compare(stringCompare('position'), stringCompare('wet_grip'), floatCompare('fitted_price'))),
        ),
        new ExclusiveTyreFilter(
          {
            id: 'fuel-best-to-worst',
            label: 'Fuel economy (A - G)',
            presence: (tyres) => true,
          },
          (tyres) => tyres.sort(compare(stringCompare('position'), stringCompare('fuel'), floatCompare('fitted_price'))),
        ),
      ],
    ),
  ]);
}
